module.exports = __webpack_public_path__ + "static/media/warning-icon.40178836.png";